import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { GenericLinkModule, MediaModule, PipesModule } from '../../..';
import { I18nModule } from '../../../../core/i18n';
import { BadgeModule } from '../../badge';
import { CampaignBannerCarouselComponent } from './container/campaign-banner-carousel.component';
import { CampaignBannerCarouselItemComponent } from './item/campaign-banner-carousel-item.component';

@NgModule({
  declarations: [CampaignBannerCarouselComponent, CampaignBannerCarouselItemComponent],
  imports: [CommonModule, I18nModule, MediaModule, BadgeModule, NzIconModule, GenericLinkModule, RouterModule, PipesModule],
  exports: [CampaignBannerCarouselComponent, CampaignBannerCarouselItemComponent],
})
export class CampaignBannerCarouselModule {}
